/* Dunknation scroll motion: reveal on scroll, image parallax and scroll linked marquee shift. No dependencies. */
(function () {
  var w = window;
  var d = document;
  if (w.__dnMotion) {
    w.__dnMotion.scan(d);
    return;
  }

  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(w.Shopify && w.Shopify.designMode);
  var live = !reduce && !design && 'IntersectionObserver' in w;
  var movers = [];
  var ticking = false;
  var revealIO = null;
  var viewIO = null;

  function update() {
    ticking = false;
    var vh = w.innerHeight;
    var vw = w.innerWidth;
    for (var i = 0; i < movers.length; i++) {
      var el = movers[i];
      var host = el.__dnHost;
      if (!host.__dnVisible || !el.isConnected) continue;
      var r = host.getBoundingClientRect();
      if (el.hasAttribute('data-dn-parallax')) {
        var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        p = Math.max(-1, Math.min(1, p));
        var amount = parseFloat(el.getAttribute('data-dn-parallax')) || 8;
        el.style.transform = 'translate3d(0,' + (-p * amount).toFixed(2) + '%,0)';
      } else {
        var k = parseFloat(el.getAttribute('data-dn-scrollx')) || 0.25;
        var x = Math.max(-0.4 * vw, Math.min(0.4 * vw, (r.top - vh) * k));
        el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      }
    }
  }

  function request() {
    if (ticking) return;
    ticking = true;
    w.requestAnimationFrame(update);
  }

  if (live) {
    revealIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var list = entry.target.__dnReveal || [];
          for (var i = 0; i < list.length; i++) list[i].classList.add('is-in');
          entry.target.__dnReveal = [];
          revealIO.unobserve(entry.target);
          /* Rows that scroll sideways reveal as one group, so swiped in cards are already visible. */
          var group = entry.target.closest('[data-dn-group]');
          if (group && !group.__dnDone) {
            group.__dnDone = true;
            var rest = group.querySelectorAll('[data-dn-reveal]');
            for (var j = 0; j < rest.length; j++) rest[j].classList.add('is-in');
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    viewIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.__dnVisible = entry.isIntersecting;
        });
        request();
      },
      { rootMargin: '20% 0px 20% 0px' }
    );
    w.addEventListener('scroll', request, { passive: true });
    w.addEventListener('resize', request);
  }

  function scan(scope) {
    scope = scope && scope.querySelectorAll ? scope : d;
    var reveals = scope.querySelectorAll('[data-dn-reveal]');
    for (var i = 0; i < reveals.length; i++) {
      var el = reveals[i];
      if (el.__dnSeen) continue;
      el.__dnSeen = true;
      if (!live) {
        el.classList.add('is-in');
        continue;
      }
      /* A fully clipped element never reports as intersecting, so clip reveals are watched through their parent. */
      var watch = el.getAttribute('data-dn-reveal') === 'clip' && el.parentElement ? el.parentElement : el;
      (watch.__dnReveal = watch.__dnReveal || []).push(el);
      revealIO.observe(watch);
    }
    if (!live) return;
    var found = scope.querySelectorAll('[data-dn-parallax],[data-dn-scrollx]');
    for (var j = 0; j < found.length; j++) {
      var m = found[j];
      if (m.__dnHost) continue;
      m.__dnHost = m.hasAttribute('data-dn-parallax') ? m.parentElement : m;
      movers.push(m);
      viewIO.observe(m.__dnHost);
    }
    request();
  }

  w.__dnMotion = { scan: scan };
  d.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { scan(d); });
  else scan(d);
})();
